import React from 'react'
import PropTypes from 'prop-types'

import moment from 'moment'

import Checkbox from 'material-ui/Checkbox'

import TimeInput from './TimeInput'
import FunctionUtils from '../../../../lambda/FunctionUtils.js'

export default class TimeView extends React.Component {

  static propTypes = {
    jobInfo: PropTypes.shape()
  }

  getModuleInfo = () => {
    return this.props.jobInfo.modules.date
  }

  getTimeInfo = () => {
    return this.getModuleInfo().time || {}
  }

  handleStartTimeChanged = (event, date) => {
    const timeInfo = this.getTimeInfo()
    const newStartTime = moment(date)
    const oldEndTime = moment(timeInfo.endTime, 'HH:mm')
    const oldStartTime = moment(timeInfo.startTime, 'HH:mm')

    // Update endTime to keep the same duration
    const diff = oldEndTime.diff(oldStartTime, 'minutes')
    const newEndTime = moment(newStartTime).add(diff, 'minutes')

    timeInfo.endTime = newEndTime.format('HH:mm')
    timeInfo.startTime = newStartTime.format('HH:mm')
    FunctionUtils.updateModule(this.props.jobInfo, '/modules/date/time/', timeInfo, false)
  }

  handleEndTimeChanged = (event, date) => {
    const newEndTime = moment(date).format('HH:mm')
    FunctionUtils.updateModule(this.props.jobInfo, '/modules/date/time/endTime', newEndTime, false)
  }

  handleTimeToggled = (ev, isInputChecked) => {
    const timeInfo = this.getTimeInfo()
    timeInfo.enabled = isInputChecked
    if (timeInfo.enabled) {
      timeInfo.startTime = moment().format('HH:mm')
      timeInfo.endTime = moment().add(30, 'minutes').format('HH:mm')
    } else {
      timeInfo.startTime = null
      timeInfo.endTime = null
    }
    FunctionUtils.updateModule(this.props.jobInfo, '/modules/date/time', timeInfo, false)
  }

  render() {
    const timeInfo = this.getTimeInfo()
    const wrongEndTime = timeInfo.enabled && (timeInfo.endTime < timeInfo.startTime)
    const endTimeBackgroundColor = wrongEndTime ? '#FFECEC' : 'white'
    return (
      <div style={styles.container}>
        <Checkbox style={{}}
          label={'Assign Time'}
          checked={timeInfo.enabled}
          onCheck={this.handleTimeToggled}/>
        { timeInfo.enabled &&
          <div style={styles.timeContainer}>
            <TimeInput
              value={moment(timeInfo.startTime, 'HH:mm').toDate()}
              onChange={this.handleStartTimeChanged} />
            <div style={styles.separator}>to</div>
            <TimeInput
              style={{ background: endTimeBackgroundColor }}
              value={moment(timeInfo.endTime, 'HH:mm').toDate()}
              onChange={this.handleEndTimeChanged} />
          </div>
        }
      </div>
    )
  }

}

const styles = {

  container: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 8
  },

  timeContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wap',
    marginTop: 8
  },

  separator: {
    marginLeft: 8,
    marginRight: 8,
    color: '#757575'
  }

}


// WEBPACK FOOTER //
// ./src/schedule/common/modules/date/TimeView.js